// The goal here is to build a simple video scrubber
// see if you can fix the keydown stuff

import React from 'react';
import ReactPlayer from 'react-player';
import { useState, useRef, useLayoutEffect, useEffect } from 'react';
import { gsap } from 'gsap';
import { Draggable } from 'gsap/Draggable';
import { formatTime, roundTo } from './helpers';
import { useSize } from './useSize';

import Box from '@mui/material/Box';
// import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import IconButton from '@mui/material/IconButton';
import SkipNextIcon from '@mui/icons-material/SkipNext';
import SkipPreviousIcon from '@mui/icons-material/SkipPrevious';
import FastForwardIcon from '@mui/icons-material/FastForward';
import FastRewindIcon from '@mui/icons-material/FastRewind';
// import Replay5Icon from '@mui/icons-material/Replay5';
// import Forward5Icon from '@mui/icons-material/Forward5';
import Typography from '@mui/material/Typography';
import PlayCircleFilledIcon from '@mui/icons-material/PlayCircleFilled';
import PauseCircleFilledIcon from '@mui/icons-material/PauseCircleFilled';

import { round10 } from '../helpers';
import CrossStartUpdateModal from './CrossStartUpdateModal';

gsap.registerPlugin(Draggable);

const DEBUG = false;
export function VideoScreen2({
  sessionVideoUrl,
  combinedStates,
  setCombinedStates,
  segmentDefinitions,
  lapData,
  liftSelectedSession,
  selectedSession,
  enhancedTelemetryByLapNumber,
}) {
  const timeBeforeLapStart = 10;
  const lapStarGapSeconds = 2;
  const animatedComponent = useRef(null);
  const size = useSize(animatedComponent);
  const vidRef = useRef(null);
  const dragBounds = useRef(null);
  const scrubby = useRef(null);
  const dragger = useRef(null);
  const [skipSec, setSkipSec] = useState(3);
  const [width, setWidth] = useState(0);
  const [firstPlay, setFirstPlay] = useState(true);
  const [vidUrlAdjusted, setVidUrlAdjusted] = useState('');
  const [isPlaying, setIsPlaying] = useState(false);
  const [dragToPct, setDragToPercentage] = useState(null);
  const [progress, setProgress] = useState({});

  const handlePlay = () => {
    setIsPlaying(true);
  };

  const handlePause = () => {
    setIsPlaying(false);
  };

  const handleEnded = () => {
    setIsPlaying(false);
  };

  function skipSecUpdater(e) {
    setSkipSec(Number(e.target.value));
  }

  function swapDesiredPausedState() {
    setIsPlaying(!isPlaying);
  }

  function skipForwardSeconds() {
    vidRef.current.seekTo(vidRef.current.getCurrentTime() + skipSec);
  }
  function skipReverseSeconds() {
    vidRef.current.seekTo(vidRef.current.getCurrentTime() - skipSec);
  }

  function jumpToLap(lapNum) {
    const jumpTime =
      lapData?.find((lap) => lap.number === lapNum).adjTimeCummLapStart +
      0.0005;
    vidRef.current.seekTo(jumpTime, 'seconds');
  }

  function skipForwardLapNew() {
    const cl = combinedStates.currLap;
    if (cl === lapData.length - 1) {
      console.log(`last recorded lap: jump to end of video`);
      vidRef.current.seekTo(1, 'fraction');
    } else {
      const nextLapStartCummTime = lapData[cl + 1].adjTimeCummLapStart;
      vidRef.current.seekTo(nextLapStartCummTime + 0.0005, 'seconds');
    }
  }

  function skipReverseLapNew() {
    const cl = combinedStates.currLap;
    if (cl === 0) {
      vidRef.current.seekTo(0, 'seconds');
    } else {
      if (combinedStates.currLapElapsedTime < lapStarGapSeconds) {
        vidRef.current.seekTo(lapData[cl - 1].adjTimeCummLapStart, 'seconds');
      } else {
        vidRef.current.seekTo(lapData[cl].adjTimeCummLapStart, 'seconds');
      }
    }
  }

  function jumpToSegment2(segVal) {
    const currLap = combinedStates.currLap;
    const lapInfo = lapData?.find((lap) => lap.number === currLap);
    if (!lapInfo.hasOwnProperty('segmentStartTimes')) {
      return;
    }
    const segStartTime = lapInfo?.segmentStartTimes[segVal];
    const adjTimeCummLapStart = lapInfo?.adjTimeCummLapStart;
    console.log(
      currLap,
      segVal,
      segStartTime,
      adjTimeCummLapStart,
      adjTimeCummLapStart + segStartTime
    );
    if (segStartTime >= 0) {
      vidRef.current.seekTo(adjTimeCummLapStart + segStartTime, 'seconds');
    }
  }

  function nextSegment() {
    const currLap = combinedStates.currLap;
    const currSeg = combinedStates.segment;
    let nextSeg;
    if (Number(currSeg) === segmentDefinitions.length) {
      nextSeg = String(1);
    } else {
      nextSeg = String(Number(currSeg) + 1);
    }
    const lapInfo = lapData?.find((lap) => lap.number === currLap);
    // need to check if segmentStartTimes exists for this lap.  if not, return.
    if (!lapInfo.hasOwnProperty('segmentStartTimes')) {
      return;
    }
    const segStartTime = lapInfo?.segmentStartTimes[nextSeg];
    const adjTimeCummLapStart = lapInfo?.adjTimeCummLapStart;
    if (segStartTime >= 0) {
      vidRef.current.seekTo(
        round10(adjTimeCummLapStart + segStartTime, -3),
        'seconds'
      );
    }
  }

  function previousSegment() {
    const currLap = combinedStates.currLap;
    const currSeg = combinedStates.segment;
    let nextSeg;
    if (Number(currSeg) === 1) {
      nextSeg = String(segmentDefinitions.length);
    } else {
      nextSeg = String(Number(currSeg) - 1);
    }
    const lapInfo = lapData?.find((lap) => lap.number === currLap);
    if (!lapInfo.hasOwnProperty('segmentStartTimes')) {
      return;
    }
    const segStartTime = lapInfo?.segmentStartTimes[nextSeg] || null;
    const adjTimeCummLapStart = lapInfo?.adjTimeCummLapStart;
    if (segStartTime >= 0) {
      vidRef.current.seekTo(
        round10(adjTimeCummLapStart + segStartTime, -3),
        'seconds'
      );
    }
  }

  // // keyboard controls
  // useEffect(() => {
  //   // bug here with 'null is not an object, evaluating vidRef.current.currentTime
  //   function detectKeyDown(e) {
  //     const expr = e.key;
  //     switch (expr) {
  //       case 'ArrowLeft':
  //         console.log('arrowLeft');
  //         console.log(vidRef.current.getCurrentTime());
  //         console.log(skipSec);
  //         vidRef.current.seekTo(vidRef.current.getCurrentTime() - skipSec);
  //         break;
  //       case 'ArrowRight':
  //         console.log('arrowRight');
  //         console.log(vidRef.current.getCurrentTime());
  //         console.log(skipSec);
  //         vidRef.current.seekTo(vidRef.current.getCurrentTime() + skipSec);
  //         break;
  //       case ' ':
  //         // setDesiredPausedState((d) => !d);
  //         setIsPlaying((p) => !p);
  //         break;
  //       default:
  //       // console.log(`not sure what to do with key ${expr}`);
  //     }
  //   }
  //   document.addEventListener('keydown', detectKeyDown, true);
  //   return () => {
  //     document.removeEventListener('keydown', detectKeyDown);
  //   };
  // }, [skipSec]);

  useLayoutEffect(() => {
    const dragBoundsWidth = size?.width;
    const scrubberWidth = scrubby.current.getBoundingClientRect().width;
    // console.log(`dragBoundsWidth fired: ${dragBoundsWidth - scrubberWidth}`);
    setWidth(dragBoundsWidth - scrubberWidth);
  }, [size]);

  useEffect(() => {
    if (firstPlay && sessionVideoUrl && (selectedSession?.crossStart !== undefined && selectedSession?.crossStart !== null)) {
      if (selectedSession?.crossStart > 15) {
        const startTime = selectedSession.crossStart - timeBeforeLapStart;
        // console.log(`adjust start time to ${startTime}`);
        // console.log(`${sessionVideoUrl}#t=${startTime}`);
        setVidUrlAdjusted(`${sessionVideoUrl}#t=${startTime}`);
      } else {
        setVidUrlAdjusted(sessionVideoUrl);
      }
      setFirstPlay(false);
    }
  }, [selectedSession.crossStart, firstPlay, sessionVideoUrl]);

  // adjusts video currentTime when scrubber moved
  useEffect(() => {
    if (dragToPct) {
      vidRef.current.seekTo(dragToPct, 'fraction');
    } else {
      // console.log(`drag percentage invalid - ${dragToPct}`);
    }
  }, [dragToPct]);

  // animates scrubber by syncing to video currentTime
  useEffect(() => {
    gsap.to(scrubby.current, {
      x: progress.played * width,
      ease: 'none',
      duration: 0,
    });
  }, [progress, width]);

  // makes scrubber draggable and records position
  useLayoutEffect(() => {
    let ctx = gsap.context(() => {
      let wasPlaying = false;
      dragger.current = Draggable.create(scrubby.current, {
        type: 'x',
        bounds: dragBounds.current,
        onPress() {
          const currentPlayState = vidRef.current.player.isPlaying;
          if (currentPlayState === true) {
            wasPlaying = true;
            handlePause();
          }
        },
        onRelease() {
          if (wasPlaying === true) {
            handlePlay();
          }
          wasPlaying = false;
        },
        onDrag() {
          // console.log(this.x, this.minX, this.maxX);
          let dragPct = this.x / this.maxX - this.minX;
          dragPct = isNaN(dragPct) ? NaN : dragPct;
          setDragToPercentage(dragPct);
        },
      });
    }, animatedComponent);
    return () => ctx.revert();
  }, []);

  function getSegmentNumber(lapdata, lapnum, elapsedtime) {
    if (!lapdata || !lapnum || !elapsedtime) {
      return 1;
    }
    const segmentStartTimes = lapdata.find(
      (lap) => lap.number === lapnum
    ).segmentStartTimes;
    if (!segmentStartTimes) return;
    const filteredEntries = Object.entries(segmentStartTimes).filter(
      ([key, value]) => value <= elapsedtime
    );
    if (filteredEntries.length > 0) {
      const [segmentNum] = filteredEntries.slice(-1)[0];
      return segmentNum;
    } else {
      //   console.log('No matching segment found.');
      return 1;
    }
  }

  function getDistance(elapsedlaptime, lapnum, telemetrydata, segnum) {
    if (Object.entries(telemetrydata).length < 1) return;
    const dst = telemetrydata?.laps?.[lapnum]?.find(
      (m) => m.Time === round10(elapsedlaptime, -1)
    )?.Distance;
    // console.log(round10(elapsedlaptime, -1), dst, segnum);
    return dst;
  }

  // setCombinedStates functions
  function timeUpdater(progress) {
    setProgress(progress);
    const ct = round10(progress.playedSeconds, -3);
    // get current lap number
    const currLapArray = lapData
      ?.filter((lap) => lap.adjTimeCummLapStart <= ct)
      .slice(-1)[0];
    const currLapNumber = currLapArray?.number;
    // get elapsed lap time
    const currentLapStartTime = lapData?.find(
      (lap) => lap.number === currLapNumber
    ).adjTimeCummLapStart;
    const elapsedLapTime = round10(ct - currentLapStartTime, -3);
    // get current segment
    const segmentNumber = getSegmentNumber(
      lapData,
      currLapNumber,
      elapsedLapTime
    );
    const segmentDistance = getDistance(
      elapsedLapTime,
      currLapNumber,
      enhancedTelemetryByLapNumber,
      segmentNumber
    );
    // console.log(ct);
    setCombinedStates({
      ...combinedStates,
      currLap: currLapArray.number,
      currLapElapsedTime: elapsedLapTime,
      segment: Number(segmentNumber),
      videoCurrentTime: ct,
      segmentDistance: segmentDistance,
    });
  }

  return (
    <Box
      ref={animatedComponent}
      sx={{ 
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        minHeight: 0
      }}
    >
      <Box 
        sx={{ 
          flexGrow: 1, 
          minHeight: 0,
          display: 'flex',
          flexDirection: 'column',
          position: 'relative'
        }}
      >
        <CrossStartUpdateModal
          liftSelectedSession={liftSelectedSession}
          selectedSession={selectedSession}
          combinedStates={combinedStates}
        />
        
        {/* Video container with proper height constraints */}
        <Box
          sx={{
            flexGrow: 1,
            minHeight: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            height: '100%',
            minHeight: 200,
            padding: 1
          }}
        >
          <Box
            sx={{
              position: 'relative',
              // Use modern aspect-ratio property
              aspectRatio: '16 / 9',
              width: '100%',
              height: 'auto',
              maxWidth: '100%',
              maxHeight: '100%',
              // Prevent video from becoming too wide on large screens
              // Calculate max width based on height to maintain aspect ratio
              maxWidth: 'min(100%, calc(100vh * 16 / 9 - 300px))',
              // Ensure it doesn't exceed container height
              '@media (max-aspect-ratio: 16/9)': {
                height: '100%',
                width: 'auto',
                maxWidth: 'none'
              },
              // For very wide screens, limit width to prevent super wide video
              '@media (min-width: 1200px)': {
                maxWidth: 'min(100%, 1200px)'
              },
              // Fallback for older browsers
              '@supports not (aspect-ratio: 16 / 9)': {
                width: '100%',
                height: 0,
                paddingBottom: '56.25%', // 16:9 aspect ratio
                maxWidth: 'min(100%, calc(100vh * 16 / 9 - 300px))',
                '& > *': {
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                }
              }
            }}
          >
            <ReactPlayer
              ref={vidRef}
              url={vidUrlAdjusted}
              progressInterval={100}
              onProgress={(progress) => {
                timeUpdater(progress);
              }}
              playing={isPlaying}
              onError={(error) => console.log(error)}
              onPlay={handlePlay}
              onPause={handlePause}
              onEnded={handleEnded}
              controls={true}
              playsinline={true}
              width="100%"
              height="100%"
              style={{
                display: 'block'
              }}
            />
          </Box>
        </Box>
      </Box>
      
      {/* Controls - fixed at bottom */}
      {!DEBUG && (
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            flexWrap: { sm: 'wrap' },
            justifyContent: 'center',
            alignItems: 'center',
            gap: { xs: 0.5, sm: 1 },
            p: { xs: 0.5, sm: 1 },
            borderTop: '1px solid #eee',
            flexShrink: 0,
            backgroundColor: 'background.paper',
            maxHeight: '150px',
            overflow: 'auto'
          }}
        >
          {/* play/pause button */}
          <Box sx={{ flexShrink: 0 }}>
            <IconButton
              size="medium"
              aria-label="play-pause"
              color="primary"
              onClick={swapDesiredPausedState}
            >
              {!isPlaying ? (
                <PlayCircleFilledIcon sx={{ fontSize: { xs: '32px', sm: '40px' } }} />
              ) : (
                <PauseCircleFilledIcon sx={{ fontSize: { xs: '32px', sm: '40px' } }} />
              )}
            </IconButton>
          </Box>
          
          {/* skip laps */}
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              border: '1px solid gray',
              borderRadius: 1,
              minWidth: 0,
              flexShrink: 0,
              width: { xs: '100%', sm: 'auto' }
            }}
          >
            <Box
              sx={{
                height: 20,
                alignItems: 'center',
                justifyContent: 'center',
                display: 'flex',
                borderBottom: '1px solid gray',
                px: 1
              }}
            >
              <Typography variant="caption">lap</Typography>
            </Box>
            <Box
              sx={{
                height: 40,
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center'
              }}
            >
              <IconButton
                aria-label="lap-reverse"
                color="primary"
                onClick={skipReverseLapNew}
                size="small"
              >
                <SkipPreviousIcon />
              </IconButton>
              <Select
                labelId="lap-select"
                id="lap-select"
                value={combinedStates.currLap}
                onChange={(e) => jumpToLap(e.target.value)}
                size="small"
                sx={{
                  minWidth: { xs: 80, sm: 120 },
                  maxWidth: { xs: 120, sm: 180 },
                  flex: 1,
                  '& .MuiSelect-select': {
                    py: 0.5
                  }
                }}
              >
                {lapData?.map((lap, index) => (
                  <MenuItem key={index} value={lap.number}>
                    {lap.number} - {formatTime(lap.time)}
                  </MenuItem>
                ))}
              </Select>
              <IconButton
                aria-label="lap-forward"
                color="primary"
                onClick={skipForwardLapNew}
                size="small"
              >
                <SkipNextIcon />
              </IconButton>
            </Box>
          </Box>
          
          {/* segment controls */}
          {Object.entries(enhancedTelemetryByLapNumber).length > 0 && (
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                border: '1px solid gray',
                borderRadius: 1,
                flexShrink: 0,
                width: { xs: '100%', sm: 'auto' }
              }}
            >
              <Box
                sx={{
                  height: 20,
                  alignItems: 'center',
                  justifyContent: 'center',
                  display: 'flex',
                  borderBottom: '1px solid gray',
                  px: 1
                }}
              >
                <Typography variant="caption">sector</Typography>
              </Box>
              <Box
                sx={{
                  height: 40,
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center'
                }}
              >
                <IconButton
                  aria-label="segment-reverse"
                  color="primary"
                  onClick={previousSegment}
                  size="small"
                >
                  <FastRewindIcon />
                </IconButton>
                <Select
                  labelId="segment-select"
                  id="segment-select"
                  value={combinedStates.segment || 1}
                  onChange={(e) => jumpToSegment2(e.target.value)}
                  size="small"
                  sx={{
                    minWidth: 60,
                    flex: 1,
                    '& .MuiSelect-select': {
                      py: 0.5
                    }
                  }}
                >
                  {segmentDefinitions?.map((seg, index) => (
                    <MenuItem key={index} value={seg.segment}>
                      {seg.segment}
                    </MenuItem>
                  ))}
                </Select>
                <IconButton
                  aria-label="segment-forward"
                  color="primary"
                  onClick={nextSegment}
                  size="small"
                >
                  <FastForwardIcon />
                </IconButton>
              </Box>
            </Box>
          )}

          {/* skip seconds */}
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              border: '1px solid gray',
              borderRadius: 1,
              flexShrink: 0,
              width: { xs: '100%', sm: 'auto' }
            }}
          >
            <Box
              sx={{
                height: 20,
                alignItems: 'center',
                justifyContent: 'center',
                display: 'flex',
                borderBottom: '1px solid gray',
                px: 1
              }}
            >
              <Typography variant="caption">seconds</Typography>
            </Box>
            <Box
              sx={{
                height: 40,
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center'
              }}
            >
              <IconButton
                aria-label="skip-reverse"
                color="primary"
                onClick={skipReverseSeconds}
                size="small"
              >
                <SkipPreviousIcon />
              </IconButton>
              <Select
                labelId="skip-seconds-select"
                id="skip-seconds-select"
                value={skipSec}
                onChange={(e) => skipSecUpdater(e)}
                size="small"
                sx={{
                  minWidth: 60,
                  flex: 1,
                  '& .MuiSelect-select': {
                    py: 0.5
                  }
                }}
              >
                <MenuItem value="1">1s</MenuItem>
                <MenuItem value="2">2s</MenuItem>
                <MenuItem value="3">3s</MenuItem>
                <MenuItem value="5">5s</MenuItem>
                <MenuItem value="7">7s</MenuItem>
                <MenuItem value="10">10s</MenuItem>
                <MenuItem value="30">30s</MenuItem>
              </Select>
              <IconButton
                aria-label="skip-forward"
                color="primary"
                onClick={skipForwardSeconds}
                size="small"
              >
                <SkipNextIcon />
              </IconButton>
            </Box>
          </Box>
          
          {/* elapsed timer */}
          <Box
            sx={{
              width: { xs: '100%', sm: 100 },
              maxWidth: 100,
              display: 'flex',
              flexDirection: 'column',
              border: '1px solid gray',
              borderRadius: 1,
              flexShrink: 0
            }}
          >
            <Box
              sx={{
                height: 20,
                alignItems: 'center',
                justifyContent: 'center',
                display: 'flex',
                borderBottom: '1px solid gray',
                px: 1
              }}
            >
              <Typography variant="caption">lap timer</Typography>
            </Box>
            <Box
              sx={{
                height: 40,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Typography variant="body2">
                {combinedStates.currLapElapsedTime
                  ? formatTime(roundTo(combinedStates.currLapElapsedTime))
                  : '00:00'}
              </Typography>
            </Box>
          </Box>
        </Box>
      )}
      
      {/* Scrubber */}
      <Box
        sx={{
          borderRadius: 1,
          flexShrink: 0,
          px: 1,
          py: 0.5
        }}
      >
        <Box
          id="time-guide"
          ref={dragBounds}
          sx={{
            backgroundColor: 'black',
            height: 10,
            borderRadius: 1
          }}
        ></Box>
        <Box
          ref={scrubby}
          sx={{
            position: 'relative',
            bottom: '1rem',
            left: 0,
            width: 20,
            height: 20,
            borderRadius: '50%',
            backgroundColor: '#e55555',
            zIndex: 1,
          }}
        ></Box>
      </Box>
    </Box>
  );
}
